import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-partnerships',
  templateUrl: './partnerships.component.html',
  styleUrls: ['./partnerships.component.scss']
})
export class PartnershipsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
